import { configService } from '@/settings/api-url'
import { segment_identify, segment_track } from '@/settings/segment';
import store from '@/store/store';


const actions = {
  async action_autoLogin({ dispatch, commit, getters }, state) {
    const token = getters.getIsToken
    if (token) {
      commit('SPINNER', true)
      configService.defaults.headers.common['Authorization'] = token
      configService.defaults.headers.common['Access-Control-Allow-Origin'] = '*';
      const { data } = await dispatch('action_getUser')
      await dispatch('action_getTraits')
      const isTestUser = data.id < 17
      commit('IS_TEST_USER', isTestUser)
      let country = getters.getCountry;
      const countryId = (country && country.id) || 2;
      if(!country) {
        await dispatch('action_getCountry', countryId);
        country = getters.getCountry
      }
      const name = `${data.first_name} ${data.last_name}`
      commit('SPINNER', false)
      dispatch('loadSegment');
      segment_identify(data.id, name, data.email, data.cellphone, data.created_at)
      // if (data) {
      //   if (data.is_active) {
      //     /**
      //      * Instancia intercom para usuarios activos
      //      */
      //     // @ts-ignore
      //     const getTraits = getters.getTraits
      //     if ((window as any).Intercom) {
      //       (window as any).Intercom('boot', {
      //         // @ts-ignore
      //         app_id: 'zj7tm5iq',
      //         email: data.email,
      //         user_id: data.id,
      //         created_at: data.created_at,
      //         name: `${data.first_name} ${data.last_name}`,
      //         phone: data.cellphone,
      //         active: data.is_active,
      //         country: country.name,
      //         total_spent: getTraits.total_spent,
      //         orders_count: getTraits.orders_count,
      //         last_order_date: getTraits.last_order_date,
      //         first_order_date: getTraits.first_order_date,
      //         total_donation_done: getTraits.total_donation_done,
      //         total_discounts: getTraits.total_discounts,
      //         used_coupons: getTraits.used_coupons && getTraits.used_coupons.split(', '),
      //         max_order: getTraits.max_order,
      //         avg_markdown: getTraits.avg_markdown,
      //         avg_order: getTraits.avg_order,
      //         failed_spent: getTraits.failed_spent,
      //         failed_donation_done: getTraits.failed_donation_done,
      //         failed_discounts: getTraits.failed_discounts,
      //         failed_max_order: getTraits.failed_max_order,
      //         failed_avg_order: getTraits.failed_avg_order,
      //         failed_coupons: getTraits.failed_coupons && getTraits.failed_coupons.split(', '),
      //         failed_different_products: getTraits.failed_different_products,
      //         different_products: getTraits.different_products,
      //         failed_orders_count: getTraits.failed_orders_count
      //       })
      //     }
      //   }
      // }
    }
  },
  async action_postLogin({ dispatch, commit }, payload) {
    try {
      const res = await configService('/auth/login.json', {
        method: 'POST',
        data: payload
      })
      const { data } = res
      const token = data.user.auth_token
      const user = data.user;
      commit('IS_TOKEN', token)
      dispatch('loadSegment');
      dispatch('action_autoLogin')
      if (
        store.getters.getIsToken &&
        store.getters.getCart &&
        store.getters.getCart.token_encode
      ) {
        await dispatch('action_linkCartWithUser');
      }
      return res
    } catch (error) {
      return Promise.reject(error)
    }
  },
  async action_postSignup({ dispatch, commit }, dataReg) {
    try {
      const res = await configService('/user', {
        method: 'POST',
        data: dataReg
      })
      segment_track('user-created', res.data.user);
      return res
    } catch (error) {
      return Promise.reject(error)
    }
  },
  loadSegment() {
    new Promise((resolve, reject) => {
      const win = window as any;
      if (!win.analytics) {
        let analytics = (win.analytics = win.analytics || []);
        if (!analytics.initialize)
          if (analytics.invoked)
            win.console && console.error && console.error("Segment snippet included twice.");
          else {
            analytics.invoked = !0;
            analytics.methods = [
              "trackSubmit",
              "trackClick",
              "trackLink",
              "trackForm",
              "pageview",
              "identify",
              "reset",
              "group",
              "track",
              "ready",
              "alias",
              "debug",
              "page",
              "once",
              "off",
              "on",
              "addSourceMiddleware",
              "addIntegrationMiddleware",
              "setAnonymousId",
              "addDestinationMiddleware"
            ];
            analytics.factory = function(e) {
              return function() {
                let t = Array.prototype.slice.call(arguments);
                t.unshift(e);
                analytics.push(t);
                return analytics;
              };
            };
            for (let e = 0; e < analytics.methods.length; e++) {
              let t = analytics.methods[e];
              analytics[t] = analytics.factory(t);
            }
            analytics.load = function(e, t) {
              let n = document.createElement("script");
              n.type = "text/javascript";
              n.async = !0;
              n.src = "https://cdn.segment.com/analytics.js/v1/" + e + "/analytics.min.js";
              let a = document.getElementsByTagName("script")[0];
              a.parentNode.insertBefore(n, a);
              analytics._loadOptions = t;
            };
            analytics.SNIPPET_VERSION = "4.1.0";
            analytics.load("SE6Zm5Mdd51N0NlQkQi0Pv6f1j1k4Syd");
          }
      }
      resolve();
    });
  },
  async action_postResetPassword({ }, data) {
    try {
      const res = await configService(`password_resets`, {
        method: 'POST',
        data
      })
      return res
    } catch (error) {
      return Promise.reject(error)
    }
  },
  async action_putResetPassword({ }, payload) {
    try {
      const res = await configService(`/password_resets/${payload.token}?email=${payload.email}`, {
        method: 'PUT',
        data: payload.data
      })
      return res
    } catch (error) {
      return Promise.reject(error)
    }
  },

  async action_getLoginEmail({ commit }, data) {
    try {
      const res = await configService(`users/check_email_existence?email=${data}`)
      return res
    } catch (error) {
      return Promise.reject(error)
    }
  },
  async action_getLoginCellSearch({ commit }, data) {
    try {
      const res = await configService(`users/check_email_by_phone?cellphone=${data}`)
      return res
    } catch (error) {
      return Promise.reject(error)
    }
  },
  async action_getLoginTemporaryCode({ commit, dispatch }, data) {
    try {
      const res = await configService(`users/auth_by_temporary_code`, {
        method: 'POST',
        data
      })
      const token = res.data.token
      await commit('IS_TOKEN', token)
      configService.defaults.headers.common['Authorization'] = token
      configService.defaults.headers.common['Access-Control-Allow-Origin'] = '*';
      dispatch('action_autoLogin')
      return res
    } catch (error) {
      return Promise.reject(error)
    }
  },
  async action_getLoginCodeCell({ commit }, data) {
    try {
      const res = await configService(`users/get_sms_code?cellphone=${data}`)
      return res
    } catch (error) {
      return Promise.reject(error)
    }
  },

  async action_getLoginCodeCellWhatsapp({ commit }, data) {
    try {
      const res = await configService(`users/get_wa_link?cellphone=${data}`)
      return res
    } catch (error) {
      return Promise.reject(error)
    }
  },

  async action_postLoginCode({ commit, dispatch }, data) {
    try {
      const res = await configService(`users/validate_code`, {
        method: 'POST',
        data
      })
      const token = res.data.token
      await commit('IS_TOKEN', token)
      configService.defaults.headers.common['Authorization'] = token
      configService.defaults.headers.common['Access-Control-Allow-Origin'] = '*';
      if (
        store.getters.getIsToken &&
        store.getters.getCart &&
        store.getters.getCart.token_encode
      ) {
        await dispatch('action_linkCartWithUser');
      }
      return res
    } catch (error) {
      return Promise.reject(error)
    }
  },

  async action_getCreateCodeCell({ commit }, data) {
    try {
      const res = await configService(`users/get_sms_code?cellphone=${data}&is_new_user=true`)
      return res
    } catch (error) {
      return Promise.reject(error)
    }
  },

  async action_getCreateCodeCellWhatsapp({ commit }, data) {
    try {
      const res = await configService(`users/get_wa_link?cellphone=${data}&is_new_user=true`)
      return res
    } catch (error) {
      return Promise.reject(error)
    }
  },

  async action_postVerifyCodeOnly({ commit }, data) {
    // Verify without verification exist user
    try {
      const res = await configService(`users/validate_code_new_user?cellphone=${data.cellphone}`, {
        method: 'POST',
        data
      })
      return res
    } catch (error) {
      return Promise.reject(error)
    }
  }
}

export default actions
